export default __webpack_public_path__ + "images/smile_scan_mobile.627b844d22acf11db5911559709734ee.svg";